const colors = {
    spiroDiscoBall: '#27C3F3',
    lightSilver: '#D6D6D6',
}

export { colors }